import React from 'react';
import InteriorsPage from '../components/InteriorsPage/InteriorsPage';

export default function Interiors() {
    return (
        <div>
           <InteriorsPage /> 
        </div>
    )
}
